//Changes form format used in backend to form format used in frontend
//accepts backend form format as parameter and returns frontend form format as an object

export const FormatBacktoFront = (formObject) => {
  let form = [];
    let ques = [];
    let sect = [];
    let quesCount = 1;

    formObject.sections.forEach((i, indexI) => {
      let sectObject = {};
      sectObject = {
        id: i.id,
        title: i.title,
        desc: i.description,
      };
      sect.push(sectObject);
      form.push([]);

      i.questions.forEach((j, indexJ) => {
        let quesObject = {};
        quesObject = {
          id: j.id,
          quesKey: quesCount,
          quesType: j.answer_type.toString(),
          quesRequired: j.is_required === 1 ? true : false,
          question: j.title,
          option: handleOptionSpread(j.answer_type, j.answer_details),
        };
        form[indexI].push(quesCount);
        quesCount += 1;
        ques.push(quesObject);
      });
    });

    return{
      form : form,
      ques : ques,
      sect : sect,
      quesCount : quesCount
    }
}

// no backend id handling for answer options

const handleOptionSpread = (quesType, option) => {
  if (quesType === 1) {
    return [""];
  } else if (quesType === 2) {
    return [
      option.minimum_value,
      option.maximum_value,
      option.minimum_label === null ? "" : option.minimum_label,
      option.maximum_label === null ? "" : option.maximum_label,
    ];
  } else if (quesType === 3 || quesType === 4) {
    if(option === null){
      return []
    }
    let optionArray = [];
    option.forEach((i) => {
      optionArray.push(i.label);
    });
    return optionArray;
  }
};

//Changes form format from frontend to form format used in backend
//accepts form, section and question parameters
//returns backend form format object

export const FormatFronttoBack = (formTitle, formDesc, is360, formStructure, quesParams, sectParams) => {

  let form = JSON.parse(JSON.stringify(formStructure));
  let ques = JSON.parse(JSON.stringify(quesParams));
  let sect = JSON.parse(JSON.stringify(sectParams));
  let sectionArray = [];

  form.forEach((i, indexI) => {
    let questionArray = [];
    i.forEach((j, indexJ) => {
      let target = ques.find((k) => k.quesKey === j);
      if(target.id !== undefined){
        questionArray.push({
          id: target.id,
          title: target.question === null ? "" : target.question,
          answer_type: parseInt(target.quesType),
          is_required: target.quesRequired ? 1 : 0,
          answer_details: handleOptionCompile(
            parseInt(target.quesType),
            target.option
          ),
          // handling for existing question
        });
      } else {
        questionArray.push({
          title: target.question === null ? "" : target.question,
          answer_type: parseInt(target.quesType),
          is_required: target.quesRequired ? 1 : 0,
          answer_details: handleOptionCompile(
            parseInt(target.quesType),
            target.option
          ),
          // handling for new question
        });
      }
    });
    if(sect[indexI].id !== undefined){
      sectionArray.push({
        id: sect[indexI].id,
        title: sect[indexI].title === null ? "" : sect[indexI].title,
        description: sect[indexI].desc === null ? "" : sect[indexI].desc,
        questions: questionArray,
        // handling for existing section
      });
    } else {
      sectionArray.push({
        title: sect[indexI].title === null ? "" : sect[indexI].title,
        description: sect[indexI].desc === null ? "" : sect[indexI].desc,
        questions: questionArray,
        // handling for new section
      });
    }
  });

  let formObject = {
    title: formTitle,
    description: formDesc,
    is_360_form: is360 === true ? 1 : 0,
    sections: sectionArray,
  };
  return formObject;
}

// no backend id handling for answer options

const handleOptionCompile = (quesType, option) => {
  if (quesType === 1) {
    return {
      placeholder: "test",
    };
  } else if (quesType === 2) {
    return {
      minimum_value: option[0],
      maximum_value: option[1],
      minimum_label: option[2],
      maximum_label: option[3],
    };
  } else if (quesType === 3 || quesType === 4) {
    let optionArray = [];
    option.forEach((i) => optionArray.push({ label: i }));
    return optionArray;
  }
};


